import PayrollPeriod from '../model/PayrollPeriod';
import m from './module';
import { getProvisionalIdentifierForType }  from '../util'

const dateFields = [
  'pay_date',
  'locked_date',
  'start_date',
  'end_date',
  'approval_cutoff_date',
];

const type = 'PayrollPeriod';

class PayrollPeriodService {
  constructor(
    $q,
    $log,
    APIService,
    DateTimeService,
    DataSyncService,
    LogService
  ) {
    this.$q = $q;
    this.$log = $log;
    this.APIService = APIService;
    this.DateTimeService = DateTimeService;
    this.DataSyncService = DataSyncService;
    this.LogService = LogService;
    this._objectsByIdMap = {};
  }

  create(data) {
    data = data || {};
    if (!data.id) {
      data.id = getProvisionalIdentifierForType("payrollPeriod");
      this.$log.warn("Attempt to create PayrollPeriod with no ID. Setting provisional ID:", data.id);
    }

    // Convert dates
    for (let field of dateFields) {
      if (data[field]) {
        data[field] = this.DateTimeService.parseDateTimeStringFromAPI(data[field]);
      }
    }

    const model = new PayrollPeriod(data);
    return this.DataSyncService.setObjectById(type, data.id, model);
  }

  getById(id) {
    return this.DataSyncService.getLocalObjectById(type, id);
  }

  groupClaimsByPayrollPeriod(claims, descendingPeriods = true, descendingClaims = false) {
    const claimsByPayrollPeriodsId = {};
    for (let claim of claims) {
      let payrollPeriodsId = parseInt(claim.payroll_periods_id);
      if (!payrollPeriodsId) {
        this.$log.warn("Claim does not have payroll period ID:", claim);
        continue;
      }
      if (!claim.isSynced) {
        continue;
      }
      if (!(payrollPeriodsId in claimsByPayrollPeriodsId)) {
        claimsByPayrollPeriodsId[payrollPeriodsId] = [];
      }
      claimsByPayrollPeriodsId[payrollPeriodsId].push(claim);
    }

    let sortedIds = Object.keys(claimsByPayrollPeriodsId).sort();
    if (descendingPeriods) {
      sortedIds.reverse();
    }

    const grouped = [];
    for (let payrollPeriodsId of sortedIds) {
      let claims = claimsByPayrollPeriodsId[payrollPeriodsId];
      let payrollPeriod = claims[0].payrollPeriod;
      if (!payrollPeriod) {
        this.LogService.warn("No payroll period found for claim", claim);
        payrollPeriod = { id: payrollPeriodsId };
      }
      claims.sort((a, b) => new Date(a.claim_date) - new Date(b.claim_date));
      if (descendingClaims) {
        claims.reverse();
      }
      let declinedClaims = claims.filter(claim => claim.isDeclined);
      let info = {
        payrollPeriodsId,
        payrollPeriod,
        claims,
        numberOfClaims: claims.length,
        numberDeclined: declinedClaims.length,
      };
      grouped.push(info);
    }
    return grouped;
  }
}

export default PayrollPeriodService;

m.service('PayrollPeriodService', PayrollPeriodService);
